import { TimeRange } from '@mi-front/core';
import moment from 'moment';

/**
 * Rounds a timestamp to a range given by the length passed in rangeMinutes
 * For example:
 * - roundTimestampToRange(10:05:00, 30) returns [10:00:00, 10:30:00]
 * - roundTimestampToRange(10:45:00, 30) returns [10:30:00, 11:00:00]
 */
export function roundTimestampToRange(ts: number, rangeMinutes: number): [number, number] {
  const momentTs = moment(ts).set({
    seconds: 0,
    milliseconds: 0,
  });
  const remainder = rangeMinutes - (momentTs.minute() % rangeMinutes);

  const momentTsRangeEnd = moment(momentTs).add(remainder, 'minutes');
  const momentTsRangeStart = momentTsRangeEnd.clone().subtract(rangeMinutes, 'minutes');

  return [momentTsRangeStart.valueOf(), momentTsRangeEnd.valueOf()];
}

export function roundTimestampToRangeAlternative(
  ts: number,
  rangeMinutes: number,
): [number, number] {
  const rangeHalf = rangeMinutes / 2;
  const roundedMinute = Math.round(moment(ts).minute() / 15) * 15;
  const rangeCenter = moment(ts).minute(roundedMinute).second(0).millisecond(0);
  const momentTsRangeStart = moment(rangeCenter).subtract(rangeHalf, 'minutes');
  const momentTsRangeEnd = moment(rangeCenter).add(rangeHalf, 'minutes');

  return [momentTsRangeStart.valueOf(), momentTsRangeEnd.valueOf()];
}

export function toTimestampRange(range: TimeRange): TimeRange<number> {
  return {
    from: new Date(range.from).getTime(),
    to: new Date(range.to).getTime(),
  };
}
